module.exports = __webpack_public_path__ + "static/img/Character_BeLoyalty_01-01.0ec1ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Character_BeLoyalty_01-01.png
// module id = kKb9
// module chunks = 1